import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Paper,
  Box,
  Button,
  Divider,
  Card,
  CardContent,
  Grid,
  Chip
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const ChronicleExpansion = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/chronicles')}
        sx={{ mb: 3 }}
      >
        Zurück zur Chronik
      </Button>

      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#E30613' }}>
          Expansion und Wachstum
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          2000-2010: Ausbau des Streckennetzes
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Die Jahrtausendwende markierte den Beginn einer intensiven Wachstumsphase für 
          DB Regio Bus Mitte. Das Unternehmen nutzte die stabilen wirtschaftlichen Verhältnisse 
          und die wachsende Nachfrage nach öffentlichen Verkehrsmitteln für eine strategische 
          Expansion.
        </Typography>

        <Grid container spacing={3} sx={{ my: 3 }}>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%', backgroundColor: '#e8f5e8' }}>
              <CardContent>
                <Typography variant="h6" gutterBottom color="success.main">
                  Neue Linien 2000-2005
                </Typography>
                <Typography variant="body2">
                  In dieser Phase wurden mehrere neue Buslinien etabliert, die vorher 
                  unterversorgte Gebiete erschlossen. Besonders der Ausbau von Verbindungen 
                  zu Gewerbegebieten und Wohnsiedlungen stand im Fokus.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%', backgroundColor: '#e8f4fd' }}>
              <CardContent>
                <Typography variant="h6" gutterBottom color="info.main">
                  Modernisierung 2005-2010
                </Typography>
                <Typography variant="body2">
                  Die zweite Hälfte der Dekade war geprägt von der Modernisierung 
                  bestehender Linien und der Einführung neuer Fahrzeugtypen mit 
                  verbessertem Komfort und Umweltstandards.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Ein wichtiger Meilenstein war die Einführung des Rhein-Main-Verkehrsverbunds (RMV) 
          als einheitliches Tarifsystem. DB Regio Bus Mitte spielte eine aktive Rolle bei 
          der Integration ihrer Linien in dieses Verbundsystem, was den Fahrgästen erhebliche 
          Vorteile brachte.
        </Typography>

        <Card sx={{ my: 3, backgroundColor: '#fff3e0' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom color="warning.main">
              Wichtige Entwicklungen 2000-2010
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Chip label="Neue Linie 50" color="primary" sx={{ mr: 1, mb: 1 }} />
              <Chip label="Ausbau Linie 53" color="primary" sx={{ mr: 1, mb: 1 }} />
              <Chip label="RMV-Integration" color="secondary" sx={{ mr: 1, mb: 1 }} />
              <Chip label="Barrierefreie Busse" color="success" sx={{ mr: 1, mb: 1 }} />
              <Chip label="GPS-System" color="info" sx={{ mr: 1, mb: 1 }} />
            </Box>
          </CardContent>
        </Card>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Die Expansion war nicht nur quantitativ, sondern auch qualitativ. Neue 
          Niederflurbusse verbesserten die Barrierefreiheit erheblich, während die 
          Einführung von GPS-Systemen die Pünktlichkeit und Zuverlässigkeit steigerte.
        </Typography>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Bis 2010 hatte sich DB Regio Bus Mitte zu einem etablierten und geschätzten 
          Partner im regionalen Verkehrsnetz entwickelt. Die Fahrgastzahlen stiegen 
          kontinuierlich an, und das Unternehmen konnte sich als verlässlicher Teil 
          der Verkehrsinfrastruktur in der Region Frankfurt positionieren.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Card sx={{ backgroundColor: '#e3f2fd' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Quellen:
            </Typography>
            <Typography variant="body2" component="div">
              • RMV (Rhein-Main-Verkehrsverbund): Geschäftsberichte 2000-2010<br />
              • Deutsche Bahn AG: Nachhaltigkeitsberichte 2005, 2008, 2010<br />
              • Hessischer Nahverkehrsplan 2005-2010<br />
              • Verkehrsstatistiken des Hessischen Statistischen Landesamtes
            </Typography>
          </CardContent>
        </Card>
      </Paper>
    </Container>
  );
};

export default ChronicleExpansion;